import {
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";
import React from "react";
import NumberFormat from "react-number-format";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { actions } from "../../../redux/actions/alert";
import { actions as cartActions } from "../../../redux/actions/shoppingCart";
import styles from "../../../styles/global-styles";
import { ConfirmButtons } from "../../stateless/ConfirmButtons";
import Transition from "../../stateless/Transition";

const usetSyles = makeStyles(() => ({
  typography: {
    fontWeight: 400,
    marginBottom: 8,
    color: "#1C2668",
    opacity: 0.5,
  },
  chip: styles.chip,
}));

const AccesoryByBarCode = ({
  open,
  onClose,
  detailProduct,
  totalAccesories,
  searchBySite,
}) => {
  const classes = usetSyles();
  const history = useHistory();
  const handleClose = () => onClose();
  console.log("detailProduct", detailProduct);
  const goToUrl = () => {
    const { brand, model, siteId, barCode } = detailProduct;
    console.log("detailProduct", detailProduct);
    if (searchBySite) {
      history.push(`/dashboard/inventario/sucursal/detalle-producto`, {
        brand,
        model,
        siteId,
        barCode,
        productTypeId: 2,
      });
    } else {
      history.push("/dashboard/inventario/detalle-producto", {
        brand,
        model,
        barCode,
        productTypeId: 2,
      });
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth={true}
      maxWidth="sm"
      keepMounted
      TransitionComponent={Transition}
      aria-labelledby="simple-dialog-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle id="simple-dialog-title" style={{ textAlign: "center" }}>
        Accesorio
        <Typography
          color="primary"
          align="justify"
          className={classes.typography}
        >
          Cantidad total: {totalAccesories} productos
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Grid
          container
          direction="row"
          justify="center"
          alignItems="center"
          spacing={2}
        >
          <Grid item xs={3} md={4} lg={3}>
            <Typography
              color="primary"
              align="justify"
              className={classes.typography}
              variant="subtitle1"
            >
              Marca
            </Typography>
            <Typography> {detailProduct.brand}</Typography>
          </Grid>
          <Grid item xs={3} md={4} lg={3}>
            <Typography
              color="primary"
              align="justify"
              className={classes.typography}
              variant="subtitle1"
            >
              Modelo
            </Typography>
            <Typography>{detailProduct.model}</Typography>
          </Grid>
          <Grid item xs={3} md={4} lg={3}>
            <Typography
              color="primary"
              align="justify"
              className={classes.typography}
              variant="subtitle1"
            >
              Subcategoría
            </Typography>
            <Chip
              label={detailProduct.subcategory_type?.name || ""}
              className={classes.chip}
            />
          </Grid>

          {!searchBySite && (
            <Grid item xs={3} md={4} lg={3}>
              <Typography
                color="primary"
                align="justify"
                className={classes.typography}
                variant="subtitle1"
              >
                Costo
              </Typography>
              <Typography>
                {" "}
                <NumberFormat
                  value={detailProduct.cost || 0}
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix={"$"}
                />
              </Typography>
            </Grid>
          )}
          <Grid item xs={3} md={4} lg={3}>
            <Typography
              color="primary"
              align="justify"
              className={classes.typography}
              variant="subtitle1"
            >
              Precio
            </Typography>
            <Typography>
              {" "}
              <NumberFormat
                value={detailProduct.price || 0}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"$"}
              />
            </Typography>
          </Grid>

          <Grid item xs={3} md={4} lg={3}>
            <Typography
              color="primary"
              align="justify"
              className={classes.typography}
              variant="subtitle1"
            >
              Descuento
            </Typography>
            <Typography>
              {" "}
              <NumberFormat
                value={detailProduct.discount || 0}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"$"}
              />
            </Typography>
          </Grid>

          {/**
          <Grid item xs={3} md={4} lg={4}>
            <Typography
              color="primary"
              align="justify"
              className={classes.typography}
              variant="subtitle1"
            >
              Código de barras
            </Typography>
            <Typography align="center">{detailProduct.barCode}</Typography>
          </Grid>
           */}

          {searchBySite && (
            <Grid item xs={3} md={4} lg={3}>
              <Typography
                color="primary"
                align="justify"
                className={classes.typography}
                variant="subtitle1"
              >
                Alias
              </Typography>
              <Typography>{detailProduct.provider?.alias || ""}</Typography>
            </Grid>
          )}
        </Grid>
        <ConfirmButtons
          acceptTitle="Ir a detalle"
          cancel={onClose}
          accept={() => goToUrl()}
        />
      </DialogContent>
    </Dialog>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
  addItemToCart: cartActions.addItemToCart,
};

export default connect(undefined, dispatch)(AccesoryByBarCode);
